/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";
import { Navbar } from "@Modules/common";
import { ITemplate } from "@Templates/ITemplate";
import { FooterSection } from "repoV2/features/CreatorPages/modules/FooterSection";
import style from "../root/classic.module.scss";
import { TestimonialSection } from "../components";
import AboutCover from "../components/AboutCover";

// TODO - @aditya: make common of this and root index (pick in phase2)
const Classic = ({
    handleSocialShare,
    // common to be used by sub-components in TemplateRoots
    hostData,
    navbarProps,
    aboutSectionProps,
    testimonialsSectionProps,
    footerSectionProps,
}: ITemplate.IProps): JSX.Element => {
    return (
        <div className={style.root}>
            <Navbar {...navbarProps} />
            <div className={style.hostIntro}>
                <AboutCover {...aboutSectionProps} />
            </div>
            <TestimonialSection {...testimonialsSectionProps} />
            <FooterSection {...footerSectionProps} />
            <div className={style.stickyContainer}>
                <button
                    type="button"
                    className={style.spreadWordButton}
                    onClick={() => {
                        if (hostData.custom_bottom_button_cta) {
                            window.location.href =
                                hostData.custom_bottom_button_cta;
                        } else {
                            handleSocialShare("spread");
                        }
                    }}
                >
                    {hostData?.custom_bottom_button_text || "SPREAD THE WORD"}
                </button>
            </div>
        </div>
    );
};

export default Classic;
